import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_contact';
export const route = 'alt_contact/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_contact" */
/* webpackPrefetch: true */
'../components/AltContactPage')));